<template>
  <div>
      
        <div class="card card-warning">
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <input
                    type="hidden"
                    name="branch_id"
                    v-model="memberloanplan.branch_id"
                  /><input
                    type="hidden"
                    name="member_loan_plan_id"
                    v-model="memberloanplan.id"
                  /><input
                    type="hidden"
                    name="member_id"
                    v-model="memberloanplan.member_id"
                  /><input
                    type="hidden"
                    name="disbursement_id"
                    v-model="memberloanplan.disbursement_id"
                  /><input
                    type="hidden"
                    name="collection_center_id"
                    v-model="memberloanplan.collection_center_id"
                  />
                <div class="form-group">
                  <label>Amount <span class="red">*</span></label>
                  <input
                    v-model="form.amt"
                    type="text"
                    name="amt"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('amt') }"
                    required
                  />
                  <has-error :form="form" field="amt"></has-error>
                </div>
                <div class="form-group">
                  <label>Select Ledger Account </label>
                  <select
                    v-model="form.branch_ledger_id"
                    name="branch_ledger_id"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('branch_ledger_id'),
                    }"
                  >
                    <option v-if="!form.branch_ledger_id" selected value="">
                      Select Ledger Account
                    </option>
                    <option
                      :value="bank_account.id"
                      v-for="bank_account in bank_accounts"
                      :key="bank_account.id"
                    >
                      {{bank_account.name}} {{bank_account.remark}}
                    </option>
                  </select>
                  <has-error :form="form" field="branch_ledger_id"></has-error>
                </div>
                <div class="form-group">
                  <label
                    >Payment Date <span class="red">*</span></label
                  >
                  <input
                    v-model="form.paymentDate"
                    type="date"
                    name="paymentDate"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('paymentDate'),
                    }"
                    required
                  />
                  <has-error
                    :form="form"
                    field="paymentDate"
                  ></has-error>
                </div>
              </div>
              <div class="col-md-6">
                <div class="box box-default" v-if="memberloanplan.member">
                  <div class="box-header with-border">
                    <i class="fa fa-bullhorn"></i> 
                    <h3 class="box-title">Customer Details</h3>
                  </div> 
                  <div class="box-body">
                      
                    <div class="callout callout-info">
                      <h4>Member</h4>
                      <p>{{memberloanplan.member.name}}</p>
                    </div>
                    <div class="callout callout-warning">
                      <h4>Branch</h4> 
                      <p>{{memberloanplan.branch.name}}</p>
                    </div> 
                    <div class="callout callout-danger" v-if="memberloanplan.collection_center">
                      <h4>Group</h4>
                      <p>{{memberloanplan.collection_center.name}}</p>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!-- /.card-body -->
        </div>
        
  </div>
</template>
<script>
export default {
  name: 'Payment',
  data () {
    return {
      memberloanplan: {},
      bank_accounts: [],
      form: new Form({

      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EMIPayment.vue?2cbac8fc